module.exports = "\r\n<button mat-button [ngClass]=\"class\" [type]=\"type\" routerLink=\"routerLink\" (click)=\"onClickEvent.emit($event)\" [disabled]=\"disabled\">{{text}}</button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./SignClient/app/shared/controls/button.control.html
// module id = ./SignClient/app/shared/controls/button.control.html
// module chunks = main